import { PubsubReplay } from 'pubsub-replay';
const DEFAULT_ERROR_SHOW = 5000;
const DEFAULT_INFO_SHOW = 5000;
if (!window.ipEventBus) {
	window.ipEventBus = PubsubReplay;
}
export class NotificationService {
	constructor($rootScope, $timeout) {
		'ngInject';
		this.$rootScope = $rootScope;
		this.$timeout = $timeout;
		window.ipEventBus.subscribe('show-error', (channel, errorObj) => {
			$rootScope.$apply(() => {
				this.showError(errorObj);
			});
		});
		window.ipEventBus.subscribe('show-info', (channel, infoObj) => {
			$rootScope.$apply(() => {
				this.showInfo(infoObj);
			});
		});
	}

	showError(errObj) {
		let time = errObj.time ? errObj.time : DEFAULT_ERROR_SHOW;
		let dontHide = errObj.dontHide;
		this.$rootScope.globalError = {
			message: errObj.message
		};
		angular.element('html, body').animate({ scrollTop: 0 }, 500);
		if (!dontHide) {
			this.$timeout(() => {
				this.$rootScope.globalError = {};
			}, time);
		}
	}

	showInfo(infoObj) {
		let time = infoObj.time ? infoObj.time : DEFAULT_INFO_SHOW;
		let dontHide = infoObj.dontHide;
		this.$rootScope.globalNotification = {
			message: infoObj.message
		};
		angular.element('html, body').animate({ scrollTop: '0px' }, 500);
		if (!dontHide) {
			this.$timeout(() => {
				this.$rootScope.globalNotification = {};
			}, time);
		}
	}
}
